import { useSourcingExternalStore } from 'modules/sourcing-external/stores';
import { Header } from 'common/ui/Header';
import { Paths } from 'services/navigation/paths';
import { SourcingExternalSelectedCandidatesTable } from 'modules/sourcing-external/tables/SourcingExternalSelectedCandidatesTable';
import { Stack } from '@mui/material';
import { Button } from 'system/atoms';
import { useShallow } from 'zustand/react/shallow';
import { useFlag } from 'services/flags/hooks';
import { Flags } from 'services/flags/constants';
import { useOrganization } from 'core/stores/hooks/useOrganization';
import { getAnalysisTitle } from 'utils/getAnalysisTitle';

export const SourcingExternalSelectedCandidatesStep = () => {
  const {
    candidateBatch,
    selectedRows,
    onSelectedCandidatesBack,
    onSelectedCandidatesNext
  } = useSourcingExternalStore(
    useShallow((state) => ({
      candidateBatch: state.candidateBatch,
      selectedRows: state.selectedRows,
      onSelectedCandidatesNext: state.onSelectedCandidatesNext,
      onSelectedCandidatesBack: state.onSelectedCandidatesBack
    }))
  );
  const sourcingChannelSelectionEnabled = useFlag(
    Flags.SOURCING_CHANNEL_SELECTION
  );
  const organization = useOrganization();

  return (
    <Stack direction="column">
      <Header
        title={`Invite ${selectedRows.length} candidate${
          selectedRows.length !== 1 ? 's' : ''
        }`}
        subtitle={`To apply for the ${getAnalysisTitle(candidateBatch)}`}
        breadcrumbs={[
          { name: 'Analyse', path: Paths.ANALYSE },
          {
            name: getAnalysisTitle(candidateBatch),
            path: `${Paths.ANALYSE}/${candidateBatch?.id}`
          },
          { name: 'source candidates', action: onSelectedCandidatesBack }
        ]}
        currentBreadcrumb="Invite to apply"
        onBack={onSelectedCandidatesBack}
        actions={
          <Button
            variant="primary"
            onClick={() =>
              onSelectedCandidatesNext({
                isChannelSelectionFeatureFlagEnabled:
                  sourcingChannelSelectionEnabled ?? false,
                organizationChannelsEnabled: organization?.channelsEnabled ?? []
              })
            }
            disabled={selectedRows.length === 0}
          >
            Confirm and continue
          </Button>
        }
      />
      <SourcingExternalSelectedCandidatesTable />
    </Stack>
  );
};
